import { useState, useEffect } from "react";
import { fetchAuthMe } from "../api/requests/auth-requests";

export const useAuth = () => {
    const [roles, setRoles] = useState([]);
    // Oturumdaki kullanıcının kimliği — "bu kaydı ben mi yaptım" karşılaştırmaları için
    // (ör. destek mesajlarının yazan tarafa göre hizalanması). Aynı /auth/me isteğinden gelir.
    const [userId, setUserId] = useState(null);
    const [loadingUser, setLoadingUser] = useState(true);

    useEffect(() => {
        const loadAuthMe = async () => {
            setLoadingUser(true);
            try {
                const res = await fetchAuthMe();
                const json = await res.json();
                if (res.ok && json.data?.roles) {
                    setRoles(json.data.roles);
                    setUserId(json.data.id ?? null);
                }
            } catch (err) {
                console.error("Auth fetch error:", err);
            } finally {
                setLoadingUser(false);
            }
        };
        loadAuthMe();
    }, []);

    return { roles, userId, loadingUser };
};